import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LoginForm } from '@/components/auth/LoginForm';
import { OpusLogo } from '@/components/layout/OpusLogo';

export function LoginPage() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="login-ambient min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="rounded-xl border border-white/20 bg-bg-tertiary/70 backdrop-blur-xl surface-sheen shadow-overlay ring-1 ring-emerald-500/20 p-8">
          {/* Logo */}
          <div className="text-center mb-8">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl border border-emerald-500/20 bg-emerald-500/10 shadow-[0_0_45px_rgba(16,185,129,0.4),inset_0_1px_0_rgba(255,255,255,0.15)]">
              <OpusLogo className="h-10 w-10" />
            </div>
            <h1 className="text-2xl font-bold text-text-primary">Opus Recruiter CRM</h1>
            <p className="text-text-secondary mt-2">Sign in to your account</p>
          </div>

          <LoginForm />

          <p className="mt-6 text-center text-sm text-text-tertiary">
            Recruitment Made Intelligent
          </p>
        </div>
      </div>
    </div>
  );
}
